<template>
	<div class="pr-1">
		<div class="pb-2" v-if="totalSales.length == 0">
			<not-found></not-found>
		</div>
		<div v-else class="mt-n2">
			<apexchart type="line" height="310" :options="chartOptions" :series="totalSales"></apexchart>
		</div>
	</div>
</template>

<script>
import { mapActions,  mapState } from 'vuex'
import apexchart from 'vue-apexcharts'

export default {
	components: {
		apexchart,
	},
	data() {
		return {
			series: [{
				name: "Desktops",
				data: [0, 0, 0, 0, 20, 100, 20, 20, 100, 20, 20, 20]
			}],
			chartOptions: {
				chart: {
					type: 'line',
					zoom: {
						enabled: false
					},
					toolbar: {
						show: false,
					}
				},
				colors: ['#512DA8'],
				dataLabels: {
					enabled: true,
					formatter: (val) => {
						return this.$options.filters.toNumber(val)
					}
				},
				stroke: {
					curve: 'smooth'
				},
				grid: {
					row: 
					{
						colors: ['#f3f3f3', 'transparent'],
						opacity: 0.5
					},
				},
				xaxis: {
					categories: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'],
				}
			},
		}
	},
	computed: {
		...mapState('dashboard', ['listTotalSales']),

		totalSales() {
			let data = this.listTotalSales.map((val) => {
				return val
			})
			return [{
				name: "Qty",
				data: data
			}]
		}
	},
	methods: {
		...mapActions('dashboard', ['getTotalSales']),
	},
	created() {
		this.getTotalSales()
	}
};
</script>